/* ============================================================================
 * PRODUCT RACKET FORM SUBMISSION (js__product-racket-submit.js)
 * ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  /* ============================================================================
  * DEMO RACKETS
  * ============================================================================ */
  const modalDemo = document.getElementById('demoPopup');
  if (modalDemo) {
    const demos = modalDemo.querySelectorAll('.demo-racket input');
    const submitBtnDemo = modalDemo.querySelector('button');
  
    if (submitBtnDemo) {
      submitBtnDemo.disabled = true;
    
      modalDemo.addEventListener('hidden.bs.modal', () => {
        demos.forEach(demo => demo.checked = false);
        submitBtnDemo.disabled = true;
      });
    
      demos.forEach(demo => {
        demo.addEventListener('click', () => {
          submitBtnDemo.disabled = !Array.from(demos).some(d => d.checked);
        });
      });
    }
  }

  /* ============================================================================
  * STRINGING SERVICE
  * ============================================================================ */
  // --- 1. Query all elements ONCE ---

  // USE THE ID SELECTOR, NOT CLASS
  const stringingServiceModal = document.querySelector('#stringingService');
  if (!stringingServiceModal) return;

  // --- Modal Elements (Scoped to the modal) ---
  const stringStepOne = stringingServiceModal.querySelector('.process-step-1');
  const stringStepTwo = stringingServiceModal.querySelector('.process-step-2');
  const stringBrandContainer = stringingServiceModal.querySelector('.string-brands');
  const allBrandsButton = stringingServiceModal.querySelector('.string-brands button:first-child');
  const stringContent = stringingServiceModal.querySelector('.string-products');
  const allProducts = stringingServiceModal.querySelectorAll('.string-products .string-product');
  const stringingOptions = stringingServiceModal.querySelector('.stringing-options');
  const submitStringing = stringingServiceModal.querySelector('#submitStringing');
  const closeStringing = stringingServiceModal.querySelector('#closeStringing');
  const resetStringing = stringingServiceModal.querySelector('#resetStringing');

  // --- Page Elements (Global) ---
  const addStringingService = document.getElementById('addStringingService');
  const addStringing = document.getElementById('addStringing');
  const stringingBtn = document.getElementById('stringingBtn');
  const stringingCard = document.getElementById('stringingCard');
  const deleteStringing = document.getElementById('deleteStringing');
  const addCard = document.getElementById('addStringing');

  // --- 2. Create the "Roving" Proceed Button ---

  const btnProceed = document.createElement('button');
  btnProceed.className = 'btn btn-primary btn-sm btn-wide btn-proceed';
  btnProceed.innerHTML = 'Step 2';
  btnProceed.addEventListener('click', (e) => {
    e.stopPropagation(); // Stop the click from re-triggering the card click
    showNextStep();
  });
  
  // --- 3. State Variable ---

  let selectedStringData = null; // Holds data for the selected string

  // --- 4. Helper Functions ---

  function showNextStep() {
    // Read from the state object. This is cleaner.
    if (!selectedStringData) return;

    const step2Card = stringingOptions.querySelector('.string-card');

    // --- DATA-DRIVEN (No HTML Scraping) ---
    step2Card.querySelector('img').src = selectedStringData.imageSrc;
    step2Card.querySelector('img').alt = selectedStringData.imageAlt;
    step2Card.querySelector('[data-string-title]').textContent = selectedStringData.title;
    
    // Combine attributes and size
    let attributes = selectedStringData.attributes;
    if (selectedStringData.size) {
      attributes += ' ' + selectedStringData.size;
    }
    step2Card.querySelector('[data-string-attributes]').textContent = attributes;

    // Set price using innerHTML to respect "free" logic
    step2Card.querySelector('[data-string-price]').innerHTML = selectedStringData.priceHTML;
    step2Card.dataset.id = selectedStringData.id;
    // --- End Data-Driven ---

    // Switch UI
    stringStepOne.classList.remove('step-active');
    stringStepTwo.classList.add('step-active');
    stringContent.classList.remove('show');
    stringingOptions.classList.add('show');
  }

  function showPrevStep() {
    // Clear selection
    stringContent.querySelectorAll('.selected-string').forEach(card => card.classList.remove('selected-string'));
    btnProceed.remove(); // Remove the button from its old parent
    selectedStringData = null; // Clear the state

    // Switch UI
    stringStepOne.classList.add('step-active');
    stringStepTwo.classList.remove('step-active');
    stringingOptions.classList.remove('show');
    stringContent.classList.add('show');
  }

  function resetAndCloseModal() {
    if (addStringingService) addStringingService.checked = false;
    if (addStringing) addStringing.classList.remove('show');
    if (stringingBtn) stringingBtn.classList.add('show');
    if (stringingCard) stringingCard.classList.remove('show');

    stringBrandContainer?.querySelectorAll('button').forEach(btn => btn.classList.remove('active'));
    allBrandsButton?.classList.add('active');
    allProducts.forEach(product => product.classList.add('show'));
    showPrevStep();
    
    const modalInstance = bootstrap.Modal.getInstance(stringingServiceModal);
    if (modalInstance) modalInstance.hide();
  }

  // --- 5. Event Listeners (Event Delegation) ---

  // Brand Filtering (1 listener)
  stringBrandContainer?.addEventListener('click', (e) => {
    const targetButton = e.target.closest('button');
    if (!targetButton) return;

    stringBrandContainer.querySelectorAll('button').forEach(btn => btn.classList.remove('active'));
    targetButton.classList.add('active');

    // Filter logic (reads from data-brand)
    const brand = targetButton.dataset.brand;
    allProducts.forEach(product => {
      if (brand === "" || !brand || product.classList.contains(brand)) {
        product.classList.add('show');
      } else {
        product.classList.remove('show');
      }
    });
  });

  // String Selection (1 listener)
  stringContent?.addEventListener('click', (e) => {
    const clickedCard = e.target.closest('.string-product');
    // If the click was on the button itself, do nothing
    if (!clickedCard || e.target.closest('.btn-proceed')) return;

    // Check if the click was *not* on a radio or its label
    if (!e.target.closest('input[type="radio"]') && !e.target.closest('label[for]')) {
      // User clicked the card body, so check the *first available* radio
      const firstRadio = clickedCard.querySelector('input[type="radio"]:not(:disabled)');
      if (firstRadio) firstRadio.checked = true;
    }
    // If they *did* click a radio or label, we do nothing and let the browser
    // handle the checking. The rest of the code will now run.

    // Remove selection from all other cards
    stringContent.querySelectorAll('.selected-string').forEach(card => {
      card.classList.remove('selected-string');
    });

    // Add selection to this card
    clickedCard.classList.add('selected-string');

    // Now that the correct radio is checked, let's build the data
    const checkedInput = clickedCard.querySelector('input[type="radio"]:checked');
    if (!checkedInput) return; // Safety check

    // Find the label safely (it might not exist for single-variant strings)
    let sizeText = '';
    const label = clickedCard.querySelector(`label[for="${checkedInput.id}"]`);
    if (label) {
      sizeText = label.innerHTML.trim();
    }

    // Build the state object
    selectedStringData = {
      id: checkedInput.value,
      title: clickedCard.dataset.title,
      priceHTML: clickedCard.querySelector('[data-string-price]').innerHTML,
      attributes: clickedCard.dataset.attributes,
      imageSrc: clickedCard.dataset.imageSrc,
      imageAlt: clickedCard.dataset.imageAlt,
      size: sizeText // Use the safely-found text
    };

    // Move the *single* btnProceed into the card.
    clickedCard.appendChild(btnProceed);
  });

  // Back to Step 1 Button
  resetStringing?.addEventListener('click', showPrevStep);
  
  // Close / Delete Buttons (Combined)
  closeStringing?.addEventListener('click', resetAndCloseModal);
  deleteStringing?.addEventListener('click', resetAndCloseModal);

  // Final Submit Button (Add to Card)
  submitStringing?.addEventListener('click', () => {
    if (!addCard) return;

    // 1. Get data from Step 2 card
    const step2Card = stringingOptions.querySelector('.string-card');
    
    // 2. Populate the card on the main page
    addCard.querySelector('img').src = step2Card.querySelector('img').src;
    addCard.querySelector('img').alt = step2Card.querySelector('img').alt;
    addCard.querySelector('[data-string-title]').textContent = step2Card.querySelector('[data-string-title]').textContent;
    addCard.querySelector('[data-string-attributes]').textContent = step2Card.querySelector('[data-string-attributes]').textContent;
    // Use innerHTML for the price
    addCard.querySelector('[data-string-price]').innerHTML = '+ ' + step2Card.querySelector('[data-string-price]').innerHTML;
    addCard.dataset.id = step2Card.dataset.id;

    // 3. Get options (Scoped queries)
    const customTension = stringingOptions.querySelector('#customTension')?.checked;
    let tensionText = 'Tension: ';
    if (customTension) {
      const mains = stringingOptions.querySelector('[name="mainsTension"]')?.value || 'N/A';
      const crosses = stringingOptions.querySelector('[name="crossesTension"]')?.value || 'N/A';
      tensionText += `${mains}/${crosses} kg`;
    } else {
      tensionText += 'Average';
    }
    addCard.querySelector('.data-tension').innerHTML = tensionText;

    // 4. Get finishes
    let finishProps = [];
    if (stringingOptions.querySelector('[name="add-logo"]')?.checked) {
      finishProps.push('Logo');
    }
    if (stringingOptions.querySelector('[name="add-protection"]')?.checked) {
      finishProps.push('Protection');
    }
    
    addCard.querySelector('.data-finish').innerHTML = finishProps.length > 0 
      ? 'Finishes: ' + finishProps.join(', ') 
      : '';

    // 5. Show the card on the main page
    stringingCard.classList.add('show');
    stringingBtn.classList.remove('show');
    
    // 6. Hide the Bootstrap modal
    const modalInstance = bootstrap.Modal.getInstance(stringingServiceModal);
    if (modalInstance) modalInstance.hide();
  });
});

// --- Racket/Demo/Stringing Cart Function ---
window.onSubmitCartForm = async (form, event) => {
  event.preventDefault();
  
  // 1. Cache form elements
  const btnTxt = form.querySelector('.btn-cart span:first-child');
  const input = form.querySelector('input[name="quantity"]');
  const quantity = form.querySelector('.cart-quantity');
  const btnMinus = form.querySelector('.btn-minus');
  const btnPlus = form.querySelector('.btn-plus');
  const submitButton = btnTxt ? btnTxt.closest('button') : null;

  // 2. Set loading state
  btnTxt.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>`;
  if (submitButton) submitButton.disabled = true;

  // 3. Prepare fetch variables
  let fetchBody;
  let fetchHeaders = {};
  let isJson = false;

  const stringingServiceCheck = form.querySelector('[name="stringingService"]');
  const demoRacketCheck = form.querySelector('.demo-racket input:checked');

  // 4. Build the fetchBody based on logic
  if (stringingServiceCheck && stringingServiceCheck.checked) {
    // --- STRINGING SERVICE LOGIC ---
    disableBtns(form); // Disable +/-
    isJson = true;
    const addCard = form.querySelector('#addStringing');
    const stringId = addCard ? addCard.dataset.id : null;
    const currentQuantity = input.value;

    if (!stringId) {
      // ERROR CASE
      btnTxt.innerHTML = `${window.theme.product.addToCart}`;
      alert('Please Select String & Options.');
      enableBtns(form); // Re-enable +/-
      if(btnMinus) btnMinus.disabled = true;
      if (btnPlus && btnPlus.dataset.max == 1) {
        btnPlus.disabled = true;
      }
      if (submitButton) submitButton.disabled = false;
      return;
    }

    const data = {
      items: [
        { id: form.querySelector('.stringing-service').dataset.id, quantity: currentQuantity, properties: {} }, 
        { id: form.querySelector('[name="id"]').value, quantity: currentQuantity },
        { quantity: currentQuantity, id: stringId }
      ]
    };

    const tensionText = addCard.querySelector('.data-tension')?.innerHTML || '';
    const finishText = addCard.querySelector('.data-finish')?.innerHTML || '';

    if (tensionText) {
      data.items[0].properties['Tension'] = tensionText.split(': ')[1];
      if (finishText) {
        data.items[0].properties['Tension'] += ', ' + finishText.split(': ')[1];
      }
    }
    
    fetchBody = JSON.stringify(data);
    
  } else if (demoRacketCheck) {
    // --- DEMO RACKET LOGIC ---
    isJson = true;
    const data = {
      items: [
        {
          quantity: 1,
          id: demoRacketCheck.value
        }
      ]
    };
    fetchBody = JSON.stringify(data);

  } else {
    // --- DEFAULT RACKET LOGIC ---
    disableBtns(form); // Disable +/-
    isJson = false;
    fetchBody = new FormData(form);
  }

  // 5. Perform the single fetch call
  if (isJson) {
    fetchHeaders["Content-Type"] = "application/json";
  }
  
  const response = await fetch('/cart/add.js', { 
    method: 'POST', 
    body: fetchBody,
    headers: fetchHeaders
  });

  // 6. Handle success and reset form
  btnTxt.innerHTML = `${window.theme.product.addToCart}`;
  window.refreshCartContents(response);
  bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show();

  if (submitButton) submitButton.disabled = false;

  // Reset quantity inputs (if they exist)
  if (input && quantity && btnMinus && btnPlus) {
    input.value = 1;
    quantity.textContent = 1;
    
    // Manually set the state just like onChangeProductOption does
    btnMinus.disabled = true; 

    // Re-check the max quantity from the button's data attribute
    let cleanMax = parseInt(btnPlus.dataset.max);
    if (isNaN(cleanMax)) {
        // If max was "null" or "undefined", treat as 0
        cleanMax = 0;
    }
    
    btnPlus.disabled = (1 >= cleanMax);
    
    // We DO NOT call enableBtns().
  }
}